import type { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { forwardRef } from 'react';

export type HorizontalScrollingProps = FlexProps;
export const HorizontalScrolling = forwardRef<
  HTMLDivElement,
  HorizontalScrollingProps
>(({ children, ...props }: HorizontalScrollingProps, ref) => {
  return (
    <Flex
      ref={ref}
      className="light-scrollbar"
      px="16px"
      gap="16px"
      overflowX="scroll"
      overflowY="hidden"
      flexWrap="nowrap"
      {...props}
    >
      {children}
    </Flex>
  );
});
HorizontalScrolling.displayName = 'HorizontalScrolling';
